import { gql } from "@apollo/client";
import { WALL_POST_FIELDS } from "../queries/wall";

export const CREATE_WALL_POST = gql`
  ${WALL_POST_FIELDS}
  mutation CreateWallPost($input: WallPostInput!) {
    createWallPost(input: $input) {
      ...wallPostFields
    }
  }
`;

export const EDIT_WALL_POST = gql`
  ${WALL_POST_FIELDS}
  mutation EditWallPost($input: EditWallPostInput!) {
    editWallPost(input: $input) {
      ...wallPostFields
    }
  }
`;

export const DELETE_WALL_POST = gql`
  mutation DeleteWallPost($id: String!) {
    deleteWallPost(id: $id) {
      affectedRows
    }
  }
`;

export const TOGGLE_PIN_WALL_POST = gql`
  ${WALL_POST_FIELDS}
  mutation TogglePinWallPost($id: String!) {
    togglePinWallPost(id: $id) {
      ...wallPostFields
    }
  }
`;

export const ADD_WALL_COMMENT = gql`
  ${WALL_POST_FIELDS}
  mutation AddWallComment($input: WallCommentInput!) {
    addWallComment(input: $input) {
      ...wallPostFields
    }
  }
`;

export const EDIT_WALL_COMMENT = gql`
  ${WALL_POST_FIELDS}
  mutation EditWallComment($input: EditCommentInput!) {
    editWallComment(input: $input) {
      ...wallPostFields
    }
  }
`;

export const DELETE_WALL_COMMENT = gql`
  ${WALL_POST_FIELDS}
  mutation DeleteWallComment($postId: String!, $commentId: String!) {
    deleteWallComment(postId: $postId, commentId: $commentId) {
      ...wallPostFields
    }
  }
`;

export const TOGGLE_WALL_REACTION = gql`
  ${WALL_POST_FIELDS}
  mutation ToggleWallReaction($input: WallReactionInput!) {
    toggleWallReaction(input: $input) {
      ...wallPostFields
    }
  }
`;
